import ListTemplate from 'components/template/ListTemplate';

import React, { FC } from 'react';
import { useQueryFilterHistorico } from './hooks/useQueryFilterHistorico';
import { useHeaderHistorico } from './hooks/useHeaderHistorico';
import { useQueryPermissions } from 'pages/coleta/listar/hooks/useQueryPermissions';
import { useTransformFatura } from './hooks/useTransformHistorico';

const PageListHistoricoPrePago: FC<any> = () => {
    const props = useQueryFilterHistorico();

    const permissions = useQueryPermissions();
    const colunas = useHeaderHistorico(permissions);
    const data = useTransformFatura(props, permissions);

    return (
        <ListTemplate
            browserTitle="Histórico Pré-Pago"
            colunas={colunas}
            data={data}
            {...props}
        />
    );
};
export default PageListHistoricoPrePago;
